/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreateDocumentFolderRequestDocumentFolder
 */
export interface CreateDocumentFolderRequestDocumentFolder {
  /**
   * フォルダ名
   * @type {string}
   * @memberof CreateDocumentFolderRequestDocumentFolder
   */
  name: string
}

export function CreateDocumentFolderRequestDocumentFolderFromJSON(
  json: any
): CreateDocumentFolderRequestDocumentFolder {
  return CreateDocumentFolderRequestDocumentFolderFromJSONTyped(json, false)
}

export function CreateDocumentFolderRequestDocumentFolderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateDocumentFolderRequestDocumentFolder {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: json['name']
  }
}

export function CreateDocumentFolderRequestDocumentFolderToJSON(
  value?: CreateDocumentFolderRequestDocumentFolder | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name
  }
}
